import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const ddlSchema: Schema = {
  title: 'Running DDL (e.g.  Add Index)',
  level: 2,
  columns: commonColumns
}
